import { render } from "./JobOpening.vue?vue&type=template&id=8fd63c28&scoped=true"
import script from "./JobOpening.vue?vue&type=script&lang=js"
export * from "./JobOpening.vue?vue&type=script&lang=js"

import "./JobOpening.vue?vue&type=style&index=0&id=8fd63c28&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd63c28"]])

export default __exports__